﻿export const hasValueForQueryParameter = (value) => {
  if (Array.isArray(value)) return !!value.length;

  return !!value;
};
